module.exports = __webpack_public_path__ + "static/4-IMG-4701-ec0e37305fd465f92469b9abd7af78a9.jpg";